import {inject, Injectable} from '@angular/core';
import {SafetyReport} from '@models';
import {collection, getDocs, orderBy, query, where} from 'firebase/firestore';
import {FirebaseInitService} from '../shared/firebase-init.service';

@Injectable({
	providedIn: 'root'
})
export class ReportQueryService {
	private readonly firebaseInit = inject(FirebaseInitService);

	private get collectionRef() {
		return collection(this.firebaseInit.firestore, 'reports');
	}

	async getForUser(userUid: string): Promise<SafetyReport[]> {
		if (!userUid) {
			return [];
		}
		const reportsQuery = query(this.collectionRef, where('reporterUid', '==', userUid), orderBy('createdAt', 'desc'));
		const snapshot = await getDocs(reportsQuery);
		return snapshot.docs.map(docSnapshot => ({
			uuid: docSnapshot.id,
			...(docSnapshot.data() as Omit<SafetyReport, 'uuid'>)
		}));
	}

	async getAll(): Promise<SafetyReport[]> {
		const reportsQuery = query(this.collectionRef, orderBy('createdAt', 'desc'));
		const snapshot = await getDocs(reportsQuery);
		return snapshot.docs.map(docSnapshot => ({
			uuid: docSnapshot.id,
			...(docSnapshot.data() as Omit<SafetyReport, 'uuid'>)
		}));
	}
}
